<template>
  <transition name="confirm-modal-fade">
    <div
      class="confirm-modal"
      v-if="visible"
      @keydown.esc.prevent="closeModal"
      tabindex="0"
    >
      <div class="confirm-modal__overlay" @click="closeModal"></div>
      <div class="confirm-modal__content" role="dialog" aria-modal="true">
        <header class="confirm-modal__header">
          <h1 class="confirm-modal__title">{{ title }}</h1>
          <button class="confirm-modal__close" @click="closeModal">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
              class="confirm-modal__close-icon"
            >
              <path
                d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"
              ></path>
            </svg>
          </button>
        </header>
        <main class="confirm-modal__body">
          <div v-html="content"></div>
        </main>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeyDown);
    console.log("Modal Created");
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    handleKeyDown(e) {
      if (e.key === "Escape") {
        this.closeModal();
      }
    },
  },
};
</script>

<style scoped>
.confirm-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
}

.confirm-modal__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.confirm-modal__content {
  position: relative;
  background: #fff;
  border-radius: 8px;
  max-width: 800px;
  max-height: 94vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.confirm-modal__header,
.confirm-modal__body {
  padding: 16px;
}

.confirm-modal__header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
}

.confirm-modal__title {
  font-size: 1.475rem;
  font-weight: bold;
  margin: 0;
  flex-grow: 1;
}

.confirm-modal__close {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
}

.confirm-modal__close-icon {
  width: 30px;
  height: 30px;
}

.confirm-modal__body {
  flex-grow: 1;
  padding-top: 8px;
}

.dark .confirm-modal__content {
  background: #000;
  color: #fff;
}

.confirm-modal-fade-enter-active,
.confirm-modal-fade-leave-active {
  transition: opacity 0.2s;
}
.confirm-modal-fade-enter,
.confirm-modal-fade-leave-to {
  opacity: 0;
}
</style>